
export const common = {
  // Navigation
  contact: "Contact",
  about: "About",
  projects: "Projects",
  learnMore: "Learn More",
  contactMe: "Contact Me",
  
  // Hero Section
  heroTitle: "Iker Peralta Condes",
  heroSubtitle: "Cyber Threat Intelligence Analyst",
  heroTerminal: "> Initializing threat intelligence systems...",
  threatDetection: "Threat Detection & Analysis",
  darkWebIntel: "Dark Web Intelligence",
  threatHunting: "Threat Hunting & SOC Operations",
  
  // About Section
  aboutTitle: "About Me",
  aboutTerminal: "cat about.txt",
  aboutIntro: "Hello!! 👋 I'm Iker and I'm passionate about cybersecurity, especially analyzing threats, tracking attackers😈 and staying ahead of what they're going to do.",
  aboutP1: "My background in systems and networks gave me a solid technical foundation that I now apply to understand how attackers think and act and how to protect digital environments effectively.",
  aboutP2: "I have specialized in Cyber Threat Intelligence (CTI), Threat Detection, Threat Hunting and SOC operations, supporting Incident Response teams with actionable intelligence.",
  aboutP3: "I like to stay up to date with the latest tools, techniques and vulnerabilities, experiment with new methodologies and share IOCs with other cybersecurity professionals.",
  aboutP4: "My goal is to bring real value to every project, combining strategic vision and technical analysis capabilities as a CTI Analyst and Cybersecurity Analyst.",
  aboutP5: "I'm motivated by challenges, committed to teamwork and always looking for opportunities to grow in the cybersecurity field.",
  coreCompetencies: "// Core Competencies",
  personalIntroduction: "// Personal Introduction",
  professionalProfile: "// Professional Profile",
  linkedinTitle: "LinkedIn - Iker Peralta Condes",
  linkedinDesc: "Connect with me for professional opportunities and cybersecurity networking",
  
  // Skills
  skill1Title: "Cyber Threat Intelligence (CTI)",
  skill1Desc: "Collection, analysis, and contextualization of cyber threat intelligence",
  skill2Title: "Threat Actor Monitoring",
  skill2Desc: "Monitoring of threat actors, campaigns, and TTPs (MITRE ATT&CK-based)",
  skill3Title: "Deep & Dark Web Research",
  skill3Desc: "Deep and dark web research for threat actor profiling and early threat detection",
  skill4Title: "Intelligence Reports & IOCs",
  skill4Desc: "Development and dissemination of threat reports, Indicators of Compromise (IOCs) and TTPs",
  skill5Title: "MISP Platform Management",
  skill5Desc: "Use of advanced intelligence platforms, including MISP for threat data sharing and correlation",
  skill6Title: "SOC & IR Support",
  skill6Desc: "Support to SOC and IR teams with enriched intelligence for detection and response",
  skill7Title: "Vulnerability Tracking",
  skill7Desc: "Ongoing tracking of CVEs, zero-days, and underground forums activity",
  
  // Projects Section
  projectsTitle: "Projects",
  projectsTerminal: "ls -la projects/",
  projectsSubtitle: "Explore my contributions to the cybersecurity and threat intelligence ecosystem",
  githubTitle: "GitHub Repository",
  githubDesc: "Code repositories, CTI tools, analysis scripts and cybersecurity projects",
  githubStats: "Open Source Projects",
  twitterTitle: "X / Twitter",
  twitterDesc: "Threat analysis, IOCs, real-time research and cybersecurity insights",
  twitterStats: "Threat Intelligence Updates",
  explore: "Explore",
  active: "Active",
  contributing: "Contributing to the threat intelligence ecosystem",
  
  // Contact Section
  contactTitle: "Contact",
  contactTerminal: "establish_connection",
  contactSubtitle: "Let's connect to discuss cybersecurity and threat intelligence opportunities",
  sendMessage: "// Send Message",
  socialNetworks: "// Social Networks",
  systemStatus: "// System Status",
  
  // Form
  nameLabel: "Name",
  emailLabel: "Email",
  messageLabel: "Message",
  namePlaceholder: "Your full name",
  emailPlaceholder: "your@email.com",
  messagePlaceholder: "Tell me about your project or inquiry...",
  sendButton: "Send message",
  sending: "Sending...",
  successMessage: "✓ Message sent successfully. I'll get back to you soon.",
  errorMessage: "✗ Error sending message. Please try again.",
  
  // Status
  statusOnline: "● Online",
  responseTime: "< 24h",
  availability: "24/7",
  status: "Status:",
  responseTimeLabel: "Response Time:",
  availabilityLabel: "Availability:",
  
  // Footer
  footerText: "© 2025 Iker Peralta Condes — All Rights Reserved.",
  
  // Language
  language: "Language",
  spanish: "Español",
  english: "English"
};